<template>
  <div>
    <section>
      <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

      <b-field horizontal label="Статус">
        <b-input name="subject" expanded :value="translate(name)" disabled></b-input>
      </b-field>

      <b-field horizontal label="Текст">
        <b-input type="textarea" expanded v-model="text"></b-input>
      </b-field>

      <b-field horizontal label="Активность">
        <b-checkbox expanded v-model="enabled"></b-checkbox>
      </b-field>

      <b-field horizontal label="Отключить уведомления для следующих категорий">
        <b-taginput
            v-model="customerCategoriesWithoutNotifications"
            :data="filteredCustomerCategories"
            autocomplete
            :open-on-focus="true"
            icon="label"
            placeholder="Добавить категорию"
            @typing="getFilteredTags"
            @add="updateAllowedTags"
            @remove="updateAllowedTags"
        >
        </b-taginput>
      </b-field>

      <b-field horizontal>
        <p class="control">
          <b-button label="Сохранить" type="is-primary" @click="edit()" :disabled="loading"/>
        </p>
      </b-field>
    </section>

    <hr/>

    <section>
      <b-field horizontal label="Тестовый номер телефона">
        <b-input name="subject" expanded v-model="testPhone"></b-input>
      </b-field>

      <b-field horizontal label="Имя клиента *{client}*">
        <b-input name="subject" expanded v-model="testClient"></b-input>
      </b-field>

      <b-field horizontal label="Сумма заказа *{sum}*">
        <b-input name="subject" expanded v-model="testSum"></b-input>
      </b-field>

      <b-field horizontal label="Номер заказа *{number}*">
        <b-input name="subject" expanded v-model="testNumber"></b-input>
      </b-field>

      <b-field horizontal label="Адрес *{address}*">
        <b-input name="subject" expanded v-model="testAddress"></b-input>
      </b-field>

      <b-field horizontal>
        <p class="control">
          <b-button label="Отправить тестовое сообщение с текстом" type="is-primary" @click="sendTestMessage()"
                    :disabled="loading || (!text || !testPhone)"/>
        </p>
      </b-field>
    </section>

    <hr/>

    <section class="section">
      <div class="container">

        <h1 class="title is-4">Поддерживаемые переменные в сообщении</h1>

        <ul class="content">
          <li><code><b>{number}</b></code> — номер заказа. <i>Пример: 112421</i></li>
          <li><code><b>{sum}</b></code> — сумма заказа. <i>Пример: 15000</i></li>
          <li><code><b>{client}</b></code> — имя клиента. <i>Пример: Александр</i></li>
          <li><code><b>{address}</b></code> — адрес заказа. <i>Пример: Павлодар, Ленина 45</i></li>
        </ul>

        <h2 class="title is-5 mt-5">Условное форматирование</h2>
        <p>Вы можете скрывать части текста или показывать альтернативный текст в зависимости от наличия значения переменной.</p>

        <div class="card my-4">
          <header class="card-header">
            <p class="card-header-title">
              Скрыть текст, если переменной нет
            </p>
          </header>
          <div class="card-content">
            <p>Пример шаблона:</p>
            <pre><code>Ваш заказ {number} {?address}по адресу {address}{/address}</code></pre>
            <p>Если адрес не указан, вывод:</p>
            <pre><code>Ваш заказ 111</code></pre>
          </div>
        </div>

        <div class="card my-4">
          <header class="card-header">
            <p class="card-header-title">
              Использовать альтернативный текст (else)
            </p>
          </header>
          <div class="card-content">
            <p>Пример шаблона:</p>
            <pre><code>Ваш заказ {number} {?address}по адресу {address}{:else}для самовывоза{/address}</code></pre>
            <p>Если адрес отсутствует, вывод:</p>
            <pre><code>Ваш заказ 111 для самовывоза</code></pre>
          </div>
        </div>

        <h2 class="title is-5 mt-5">Принципы именования и рекомендации</h2>
        <div class="card my-4">
          <div class="card-content">
            <ul class="content">
              <li>Для условных блоков используйте <b>одинаковые имена</b> в открывающем и закрывающем теге:
                <code>{?address}...{/address}</code>.
              </li>
              <li>Можно использовать вложенные условные блоки, но старайтесь, чтобы текст оставался читаемым.</li>
              <li>Если переменная может быть пустой, используйте <b>{:else}</b>, чтобы показывать альтернативный текст: <code>{?address}...если
                есть...{:else}...если нет...{/address}</code>.
              </li>
              <li>Внимательнее с пунктуацией в условных блоках - всегда тестируйте сообщения</li>
            </ul>
          </div>
        </div>

        <p class="content">
          Таким образом можно:
          <ul>
            <li>Скрывать текст при отсутствии переменной</li>
            <li>Выводить альтернативный текст при отсутствии переменной</li>
            <li>Делать текст сообщений читаемым и корректным при любых данных</li>
          </ul>
        </p>

      </div>
    </section>

  </div>
</template>

<script>
import {translate} from '@/helper/deliveryStatusTranslator';
import customerCategoryRepository from '@/repository/customerCategoryRepository';
import deliveryNotificationMessagesRepository from '../../repository/deliveryNotificationMessagesRepository';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      name: null,
      text: null,
      enabled: null,
      customerCategoriesWithoutNotifications: [],
      customerCategories: [],
      customerCategoriesArray: [],
      filteredCustomerCategories: [],

      testPhone: null,
      testClient: 'Екатерина',
      testAddress: 'Павлодар, Ленина 45',
      testSum: 7000,
      testNumber: 11111,
      loading: false,
    };
  },
  methods: {
    translate,
    fetchData () {
      this.loading = true;

      customerCategoryRepository.all()
      .then(({data}) => {
        this.customerCategories = data;
        this.customerCategoriesArray = data.map((option) => option.title);
        this.filteredCustomerCategories = data.map((option) => option.title);
      })
      .then(() => {
        deliveryNotificationMessagesRepository.get(this.id)
        .then(({data}) => {
          this.name = data.name;
          this.text = data.text;
          this.enabled = data.enabled;

          this.customerCategoriesWithoutNotifications = this.customerCategories
          .filter((item) => (data?.customerCategoriesWithoutNotifications ?? []).some(x => x == item.id))
          .map((item) => item.title);

          this.updateAllowedTags();
        });
      })
      .finally(() => {
        this.loading = false;
      });
    },
    edit () {
      this.loading = true;

      let customerCategoriesIds = this.customerCategories
      .filter(item => this.customerCategoriesWithoutNotifications.includes(item.title))
      .map(item => item.id);

      deliveryNotificationMessagesRepository.update(this.id, this.text, this.enabled, customerCategoriesIds)
      .then(() => this.$router.push({name: 'DeliveryNotificationMessagesIndex'}))
      .then(() => this.$buefy.toast.open('Обновлено'))
      .catch(() => this.$buefy.toast.open('Ошибка при обновлении'))
      .finally(() => {
        this.loading = false;
      });
    },
    getFilteredTags (text) {
      if (text == null) {
        return;
      }

      this.updateAllowedTags();

      this.filteredCustomerCategories = this.filteredCustomerCategories.filter((option) => {
        let tag = option
        .toString()
        .toLowerCase();

        return tag.indexOf(text.toString().toLowerCase()) >= 0;
      });
    },
    updateAllowedTags () {
      this.filteredCustomerCategories = this.customerCategoriesArray
      .filter((e) => this.customerCategoriesWithoutNotifications.indexOf(e) === -1);
    },
    sendTestMessage () {
      this.loading = true;

      deliveryNotificationMessagesRepository.sendTestMessage(this.testPhone, this.text, this.testSum, this.testNumber, this.testClient, this.testAddress)
      .then(() => this.$buefy.toast.open('Отправлено'))
      .catch(({response}) => this.$buefy.toast.open({
        message: 'Ошибка при отправке: ' + response.data.error,
        type: 'is-danger',
      }))
      .finally(() => {
        this.loading = false;
      });
    },
  },
  mounted () {
    this.fetchData();
  },
};
</script>